// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3fidA","title":"ClientInsurance_title__Q2Wq_","itemText":"ClientInsurance_itemText__28Nan"};